import { AppstoreAddOutlined } from '@ant-design/icons';
import { useState } from 'react';
import ZoneModal from './components/ZoneModal/ZoneModal';
import { Button } from '../button';

const ZoneButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        variant="secondary"
        startIcon={<AppstoreAddOutlined />}
        onClick={() => setIsModalOpen(true)}
      >
        Rock Type Settings
      </Button>
      <ZoneModal
        isModalOpen={isModalOpen}
        handleClose={handleClose}
      />
    </>
  );
};

export default ZoneButton;
